/**
 * Youtube video Ids sample: https://www.youtube.com/embed/${videoId}
 */
export const videoIds = ["icLa0gOsMI4", "WrQmD2gYdMc", "QnmSifmK6-I", "-m3vHdfeKJA"];
